import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { usePerformerQuery, useUpdatePerformer } from "../api/queries";
import { PerformerForm } from "../ui/PerformerForm";

export function PerformerEditPage() {
  const { id } = useParams({ from: "/app/performance/performers/$id/edit" });
  const nav = useNavigate({ from: "/app/performance/performers/$id/edit" });
  const { data: performer, isLoading } = usePerformerQuery(id);
  const updatePerformer = useUpdatePerformer(id);

  if (isLoading) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              { label: "ນັກສະແດງ", to: "/app/performance/performers" },
              { label: "..." },
            ]}
          />
        </Header>
        <Main>
          <p className="text-muted-foreground">ກຳລັງໂຫລດ...</p>
        </Main>
      </>
    );
  }

  if (!performer) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              { label: "ນັກສະແດງ", to: "/app/performance/performers" },
              { label: "ບໍ່ພົບ" },
            ]}
          />
        </Header>
        <Main>
          <p className="text-destructive">ບໍ່ພົບນັກສະແດງ</p>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ນັກສະແດງ", to: "/app/performance/performers" },
            {
              label: performer.name,
              to: "/app/performance/performers/$id",
              params: { id },
            },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂນັກສະແດງ</h2>
          <p className="text-muted-foreground">{performer.name}</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <PerformerForm
            isEdit
            initialValues={{
              name: performer.name,
              phoneNumber: performer.phoneNumber ?? null,
              email: performer.email ?? null,
              notes: performer.notes ?? null,
              bankName: performer.bankName ?? null,
              bankAccount: performer.bankAccount ?? null,
              accountName: performer.accountName ?? null,
              instructorId: performer.instructorId ?? null,
              status: performer.status,
              performerType: performer.performerType ?? "other",
              defaultRoleFeeKind: performer.defaultRoleFeeKind ?? "performer",
            }}
            onSubmit={async (vals) => {
              try {
                await updatePerformer.mutateAsync(vals);
                nav({ to: "/app/performance/performers/$id", params: { id } });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/performers/$id", params: { id } })
            }
            submitting={updatePerformer.isPending}
          />
        </div>
      </Main>
    </>
  );
}
